import { useConditionValueController } from '../../../../hooks/form';
import { RelativeDateValue } from '../../../../domain';

export const useProcessRelativeDate = () => {
  const {
    field: { onChange },
  } = useConditionValueController();

  return (date: string) => {
    return onChange({ target: { value: new RelativeDateValue(date) } });
  };
};
